import { render, staticRenderFns } from "./dashboard-list.vue?vue&type=template&id=642f2c53&scoped=true&"
import script from "./dashboard-list.vue?vue&type=script&lang=js&"
export * from "./dashboard-list.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-list.vue?vue&type=style&index=0&id=642f2c53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642f2c53",
  null
  
)

export default component.exports